import jQuery from "jquery";
import CryptoJS from 'crypto-js'


jQuery(document).ready(function ($) {

    let $banner = $('#cybersec-banner');
    if ($banner.length) {

        $banner.append("<div class='toggle'></div>");
        $banner.find('.toggle').on("click", function () {
            $banner.toggleClass('compact');
        });

        // let hash = CryptoJS.MD5($banner.html());
        // let cookieBannerId = "bannerHash=" + hash.toString();

        // if (document.cookie.split('; ').find(row => row.startsWith(cookieBannerId))) {
        //     $banner.toggleClass('compact');
        // } else {
        //     $banner.append("<div class='toggle'></div>");
        //     $banner.find('.toggle').on("click", function () {
        //         $banner.toggleClass('compact');
        //
        //         if (readCookie('functional')) {
        //             document.cookie = cookieBannerId + "; expires=Fri, 31 Dec 9999 23:59:59 GMT";
        //         }
        //     });
        // }
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
});
